<template>
  <div class="section-main__warp linkage-page">
    <ioc-table
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchChange"
      @selection-change="changeSelection"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template #menuLeft>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd"
          >新增
        </el-button>
        <el-button
          size="small"
          type="info"
          icon="el-icon-delete"
          @click="handleBatchDelete"
          >批量删除
        </el-button>
      </template>
      <template #status="{ row }">
        <el-switch
          v-model="row.status"
          active-color="#407AEE"
          inactive-color="#465275"
          :active-value="0"
          :inactive-value="1"
          @change="changeType(row)"
        />
      </template>
      <template #menu="{ row, index }">
        <el-tooltip
          effect="dark"
          content="编辑"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai"
            :disabled="row.status === 0"
            @click="editRule(row)"
          />
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-shanchu"
            :disabled="row.status === 0"
            @click="deleteRule([row.ruleId])"
          />
        </el-tooltip>
      </template>
    </ioc-table>
    <AppPanel
      :width="1000"
      class="app-panel"
      :isExpand="showLinkagePanel"
      :title="title"
      @cancel="handleCloseLinkagePanel"
    >
      <linkage-opt-com
        ref="optCom"
        :nameList="option.column[2].dicData"
        v-if="showLinkagePanel"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseLinkagePanel" type="info" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSaveLinkagePanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </AppPanel>
  </div>
</template>

<script>
import utils from "$utils";
import AppPanel from "@/components/business/app-panel";
import LinkageOptCom from "@ISS/linkage/components/linkageOptCom";

export default {
  name: "linkage",
  components: { LinkageOptCom, AppPanel },
  data() {
    return {
      isAdd: true,
      subLoading: false,
      eventTypeList: [],
      cascaderOptions: [],
      option: {
        view: "预约详情",
        page: true,
        selection: true,
        index: true,
        indexLabel: "序号",
        stripe: true,
        align: "left",
        size: "small",
        maxHeight: "100%",
        labelWidth: "100px",
        menuAlign: "center",
        searchMenuSpan: 6,
        dialogHeight: 400,
        dialogWidth: "700px",
        emptyText: "暂无数据",
        column: [
          {
            label: "规则名称",
            prop: "ruleName",
            search: true,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            span: 12,
          },
          {
            label: "创建人",
            prop: "creator",
            addDisplay: true,
            editDisplay: true,
            span: 12,
          },
          {
            label: "事件类型",
            prop: "eventName",
            type: "cascader",
            search: true,
            editDisplay: true,
            viewDisplay: true,
            span: 12,
            dicData: [],
            props: {
              multiple: true,
              children: "children",
              label: "name",
              value: "id",
              checkStrictly: false,
              expandTrigger: "hover",
            },
          },
          {
            label: "优先级",
            prop: "levelNum",
            type: "select",
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 12,
            dicData: [
              {
                label: "1~10",
                value: "1~10",
              },
              {
                label: "11~20",
                value: "11~20",
              },
              {
                label: "21~30",
                value: "21~30",
              },
              {
                label: "31~40",
                value: "31~40",
              },
              {
                label: "41~50",
                value: "41~50",
              },
              {
                label: "51~60",
                value: "51~60",
              },
              {
                label: "61~70",
                value: "61~70",
              },
              {
                label: "71~80",
                value: "71~80",
              },
              {
                label: "81~90",
                value: "81~90",
              },
              {
                label: "91~100",
                value: "91~100",
              },
            ],
          },
          {
            label: "规则状态",
            prop: "status",
            type: "select",
            search: true,
            span: 12,
            dicData: [
              {
                label: "不限",
                value: -1,
              },
              {
                label: "启用",
                value: 0,
              },
              {
                label: "停用",
                value: 1,
              },
            ],
          },
        ],
      },
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      multipleSelection: [],
      searchParams: {},
      title: "",
      showLinkagePanel: false,
    };
  },
  mounted() {
    this.getAlarmTypeAndSubsystem();
    this.getList();
  },
  methods: {
    async getList() {
      const param = {
        ...this.searchParams,
        eventTypes:
          this.searchParams.eventName && this.searchParams.eventName.length > 0
            ? this.searchParams.eventName.map((v) => v[1]).join(",")
            : "",
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      const { success, returnObj } = await this.$fetch(
        "/bas/linkage-rule/getByPage.json",
        param
      );
      if (success) {
        this.tableData = returnObj.list;
        this.page.total = returnObj.total;
      }
    },
    handleSaveLinkagePanel() {
      this.$refs.optCom.$refs.refForm.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.$refs.optCom.tableData.length === 0) {
          this.$message.info("请选择触发设备！");
          return;
        }
        if (this.$refs.optCom.deviceData.length === 0) {
          this.$message.info("请选择联动设备！");
          return;
        }
        let actionDevices = [];
        this.$refs.optCom.deviceData.forEach((item, index) => {
          let par = {
            deviceId: item.resCode,
            doAction: item.doAction,
            isMonit: item.isMonit,
            orderNum: index + 1,
          };
          if (item.doAction === 6) {
            par.musicId = item.musicId;
          }
          actionDevices.push(par);
        });
        let triggerDevices = [];
        this.$refs.optCom.tableData.forEach((item) => {
          triggerDevices.push({
            deviceId: item.thirdDeviceId,
            eventType: item.eventType,
          });
        });
        let param = {
          ...this.$refs.optCom.linkInfo,
          actionDevices: actionDevices,
          triggerDevices: triggerDevices,
        };
        this.subLoading = true;
        if (this.isAdd) {
          this.$fetch("/bas/linkage-rule/add.json", param).then((res) => {
            this.subLoading = false;
            if (!res.success) {
              this.$message.error(res.msgContent);
              return;
            }
            this.$message.success("操作成功");
            this.getList();
            this.handleCloseLinkagePanel();
          });
        } else {
          this.$fetch("/bas/linkage-rule/update.json", {
            ...param,
            ruleId: this.$refs.optCom.ruleId,
          }).then((res) => {
            this.subLoading = false;
            if (!res.success) {
              this.$message.error(res.msgContent);
              return;
            }
            this.$message.success("操作成功");
            this.getList();
            this.handleCloseLinkagePanel();
          });
        }
      });
    },
    handleCloseLinkagePanel() {
      this.showLinkagePanel = false;
    },
    /**
     * 删除规则
     * @param row
     */
    deleteRule(idList) {
      const param = {
        ruleIds: idList,
      };
      this.$confirm("确定删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((confirm) => {
        console.log(confirm);
        this.$fetch("/bas/linkage-rule/batchDelete.json", param).then((res) => {
          if (!res.success) {
            this.$message.error("删除失败！");
            return;
          }
          this.$message.success("删除成功！");
          this.getList();
        });
      });
    },
    /**
     * 规则的修改
     * @param row 数据项
     */
    editRule(row) {
      this.isAdd = false;
      this.title = "修改联动规则";
      this.showLinkagePanel = true;
      const param = {
        ruleId: row.ruleId,
      };
      this.$fetch("/bas/linkage-rule/getDetails.json", param).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        if (!res.returnObj) {
          return;
        }
        res.returnObj.action = res.returnObj.action.map((item) => {
          item.code = item.resCode + item.doAction;
          return item;
        });
        this.$nextTick(() => {
          this.$refs.optCom.handleEdit(res.returnObj);
        });
      });
    },
    handleSearchChange(param) {
      console.info("param", param);
      this.page.currentPage = 1;
      this.searchParams = Object.assign({}, param);
      this.getList();
    },
    changeSelection(val) {
      this.multipleSelection = val.map((el) => {
        return el.ruleId;
      });
    },
    handleBatchDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.deleteRule(this.multipleSelection);
    },
    handleAdd() {
      this.isAdd = true;
      this.title = "新增联动规则";
      this.showLinkagePanel = true;
    },
    /**
     * 切换规则状态
     * @param row
     */
    changeType(row) {
      console.info("row", row);
      const param = {
        ruleIds: [row.ruleId],
      };
      if (row.status === 1) {
        this.$fetch("/bas/linkage-rule/batchStop.json", param).then((res) => {
          if (!res.success) {
            this.$message.error("停用失败！");
            return;
          }
          this.$message.success("停用成功！");
          this.getList();
        });
      } else {
        this.$fetch("/bas/linkage-rule/batchStart.json", param).then((res) => {
          if (!res.success) {
            this.$message.error("启用失败！");
            return;
          }
          this.$message.success("启用成功！");
          this.getList();
        });
      }
    },
    //获取系统类型数据
    getAlarmTypeAndSubsystem() {
      // 实时告警页面系统类型去除消防子系统和电器火灾
      this.$fetch("/bas/alarmSafeEvent/queryAlarmTypeAndSubsystem.json", {}).then(
        (response) => {
          let subList = [];
          response.returnObj.forEach((item, index) => {
            if (item.id != "4" && item.id != "13" && item.id != "14") {
              subList.push(item);
            }
          });
          this.option.column[2].dicData = subList;
        }
      );
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.linkage-page {
  &__search {
    display: flex;
    justify-content: space-between;
    padding: 10px 16px 3px;
    background-color: #181f2e;
  }

  &__content {
  }
}
</style>
